import React from 'react';
import PageLayout from '../components/PageLayout';
import { LinkedinLogo } from 'phosphor-react';

// Team member images
import timGillenImage from '../assets/profile/tim-gillen-profile.jpg';
import steveDixImage from '../assets/profile/Steve-Dix-profile.png';
import ruthyKirwanImage from '../assets/profile/ruthy-kirwan-profile.jpg';
import rexRudolphImage from '../assets/profile/rex-rudolph-profile.jpg';
import sueGillenImage from '../assets/profile/sue-gillen-profile.jpg';

// TeamMember Component
const TeamMember = ({ name, role, description, image, linkedinUrl }) => (
  <div className="bg-white rounded-lg shadow-md overflow-hidden transform transition duration-300 hover:shadow-lg pt-4">
    <div className="h-80 w-80 rounded-full overflow-hidden mx-auto">
      <img 
        src={image} 
        alt={`${name}, ${role} at Terrapin Networks`} 
        className="w-full h-full object-cover object-top"
      />
    </div>
    <div className="p-6">
      <h3 className="text-xl font-bold text-terrapin-blue mb-2">{name}</h3>
      <p className="text-black-800 text-lg mb-4">{role}</p>
      <p className="text-gray-600 mb-4">{description}</p>
      
      {linkedinUrl && (
        <a 
          href={linkedinUrl} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="inline-flex items-center text-terrapin-blue hover:text-terrapin-red transition-colors duration-200"
        >
          <LinkedinLogo size={20} weight="bold" className="mr-2" />
          <span>LinkedIn Profile</span>
        </a>
      )}
    </div>
  </div>
);

const OurTeam = () => {
  // Team members data
  const teamMembers = [
    {
      id: 1,
      name: 'Tim Gillen',
      role: 'Founder and President',
      description: 'The Big Boss, Main Engineer, Chief Nerd, Answer Man',
      image: timGillenImage,
      linkedinUrl: 'https://www.linkedin.com/in/timothygillen/'
    },
    {
      id: 2,
      name: 'Steve Dix',
      role: 'Senior Network Engineer',
      description: 'Our guy-on-the-ground and the perfect partner-in-tech to Tim, former member of the Michigan Air National Guard and licensed technical radio hobbyist.',
      image: steveDixImage,
      linkedinUrl: 'https://www.linkedin.com/in/steve-dix-46aa3566/'
    },
    {
      id: 3,
      name: 'Ruthy Kirwan',
      role: 'Project Manager and Customer Relations',
      description: 'Tim and Sue\'s eldest kid; when she\'s not working remotely for Terrapin from her (tiny) apartment in New York City, she\'s chasing after her two elementary-aged children',
      image: ruthyKirwanImage,
      linkedinUrl: 'https://www.linkedin.com/in/ruthykirwan/'
    },
    {
      id: 4,
      name: 'Rex Rudolph',
      role: 'Finance Director',
      description: 'CPA, owner of Padgett Business Services small business accounting, head bean-counter',
      image: rexRudolphImage,
      linkedinUrl: 'https://www.linkedin.com/in/rex-rudolph-83497b2b/'
    },
    {
      id: 5,
      name: 'Sue Gillen',
      role: 'Service Coordinator & Business Manager',
      description: 'Runs the show and has a somewhat normal life',
      image: sueGillenImage,
      linkedinUrl: null // Removed incorrect LinkedIn URL
    }
  ];

  return (
    <PageLayout
      title="Our Team"
      description={
        <div className="max-w-3xl">
          <p className="text-xl">
            Meet the talented professionals behind Terrapin Networks - a team dedicated to providing the best IT solutions for businesses in Northern Michigan.
          </p>
        </div>
      }
      variant="default"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {teamMembers.map(member => (
            <TeamMember 
              key={member.id}
              name={member.name}
              role={member.role}
              description={member.description}
              image={member.image}
              linkedinUrl={member.linkedinUrl}
            />
          ))}
        </div>

        <div className="bg-white rounded-lg shadow-md p-8 my-8">
          <h2 className="text-2xl font-bold text-terrapin-blue mb-4">Join Our Team</h2>
          <p className="text-gray-700 mb-6">
            Terrapin Networks is always looking for talented and passionate individuals to join our team. 
            If you're interested in working with us, please send your resume and cover letter to{" "}
            <a href="mailto:careers@terrapin.tech" className="text-terrapin-blue underline hover:text-terrapin-red">careers@terrapin.tech</a>.
          </p>
        </div>
      </div>
    </PageLayout>
  );
};

export default OurTeam; 